export default function AboutPage() {
  return (
    <div
      id="hero"
      className="relative flex h-fit w-full flex-col items-center justify-center px-6 md:min-h-screen md:px-10"
    >
      <h1>About</h1>
    </div>
  );
} 